import React from 'react'
import { useIntl } from 'react-intl'
import { ButtonColumn, Heading2, Page, Row, FlexContainer } from '../../components/layout'
import Logout from '../../components/Logout'
import { JobViewFilters } from '../../components/JobViewFilters'
import { CompanySwitcher } from './CompanySwitcher'
import { LanguageSwitcher } from './LanguageSwitcher'
import { settingsMessages } from './messages'
import { formatMessageSafe } from '../../util/translateInputOptions'
import styled from 'styled-components'

const HeaderContainer = styled(FlexContainer as any)`
  width: auto;
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    width: 100%;
    justify-content: space-between;
  }
`

const SettingsHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 1.5rem;
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    padding: 0 0.5rem;
    flex-direction: column;
    align-items: stretch;
  }
`

const ActionsRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1 1 auto;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  padding: 0;
  margin: 0;
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    flex-direction: column-reverse;
    align-items: stretch;
    margin: 0.5rem 0;
  }
`

export const Settings: React.FunctionComponent = () => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  return (
    <Page>
      <SettingsHeaderRow>
        <HeaderContainer>
          <Heading2>{formatMessage(settingsMessages.heading)}</Heading2>
        </HeaderContainer>
        <ActionsRow>
          <LanguageSwitcher />
          <CompanySwitcher />
          <Logout />
        </ActionsRow>
      </SettingsHeaderRow>
      <Row>
        <ButtonColumn width="100%">
          <JobViewFilters />
        </ButtonColumn>
      </Row>
    </Page>
  )
}
